// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"eb602c0b","367":"931e29a5","634":"635048a4","787":"af1d70ab"}[chunkId] + ".css";
};